import { FooterText } from "./FooterText";
export default FooterText;
